import React, { useState } from "react";
import "./ContactPage.css";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { HiOutlineMail } from "react-icons/hi";
import { HiOutlinePhone } from "react-icons/hi";
import { API_BASE } from "../../api/client";
import { STORE_PHONE_PRIMARY, STORE_PHONE_ALT } from "../../constants/storeContact";

const ContactPage = ({ hideDetails = false }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: name.trim(), email: email.trim(), phone: phone.trim(), message: message.trim() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to send message.");
      setSuccess("Thank you! We received your message and will reply shortly.");
      setName("");
      setEmail("");
      setPhone("");
      setMessage("");
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="contactSection">
        {!hideDetails && <h2>Contact Us</h2>}
        {!hideDetails && <div className="contactMap">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.4752000000003!2d72.8304!3d19.1334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b62b2e2b0a3d%3A0x3b0a3d0a3d0a3d0a!2sFour%20Bungalows%2C%20Andheri%20West%2C%20Mumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1708798894132!5m2!1sen!2sin"
            width="800"
            height="600"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Gem Fashion Studios – GEM House, Andheri West, Mumbai"
          ></iframe>
        </div>}
        <div className="contactInfo">
          {!hideDetails && <div className="contactAddress">
            <div className="address">
              <h3>Visit Us</h3>
              <div className="addressItem">
                <span className="addressIcon" aria-hidden="true">
                  <HiOutlineLocationMarker />
                </span>
                <p>
                  GEM House, 5/54, RSC-2, Four Bungalows, Mhada Rd,
                  <br />
                  SV Patel Nagar, Andheri West, Mumbai, Maharashtra 400053
                </p>
              </div>
              <div className="addressItem">
                <span className="addressIcon" aria-hidden="true">
                  <HiOutlineMail />
                </span>
                <p>
                  <a href="mailto:gemboutiqueinquiries@gmail.com">gemboutiqueinquiries@gmail.com</a>
                </p>
              </div>
              <div className="addressItem">
                <span className="addressIcon" aria-hidden="true">
                  <HiOutlinePhone />
                </span>
                <p>
                  <a href={`tel:${STORE_PHONE_PRIMARY.tel}`}>{STORE_PHONE_PRIMARY.display}</a>
                  {" · "}
                  <a href={`tel:${STORE_PHONE_ALT.tel}`}>{STORE_PHONE_ALT.display}</a>
                  <span className="addressLabel">Customer Care</span>
                </p>
              </div>
            </div>
          </div>}
          <div className="contactForm">
            <h3>Get In Touch</h3>
            {success && (
              <div className="contactSuccess" role="status">
                {success}
              </div>
            )}
            {error && (
              <div className="contactError" role="alert">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                value={name}
                placeholder="Name *"
                onChange={(e) => setName(e.target.value)}
                required
                disabled={submitting}
              />
              <input
                type="email"
                value={email}
                placeholder="Email address *"
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={submitting}
              />
              <input
                type="tel"
                value={phone}
                placeholder="Phone number"
                onChange={(e) => setPhone(e.target.value)}
                disabled={submitting}
              />
              <textarea
                rows={8}
                cols={40}
                placeholder="Your Message *"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                disabled={submitting}
              />
              <button type="submit" disabled={submitting}>
                {submitting ? "Sending…" : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
